export default __webpack_public_path__ + "static/media/LY.5b82a613.svg";